import React from "react";
import { arrayOf, object, bool, string, oneOf } from "prop-types";
import { MultiImageBlock as MultiImageBlockComponent } from "../../sharedComponents/MultiImageBlock";
import * as styles from "./MultiImageBlock.module.scss";

const MultiImageBlock = ({
	cloudinaryImages,
	images,
	logo,
	logoPosition,
	populateImagesRightToLeft,
	populateImagesAsRows,
	columnProportions,
	photoCredit,
}) => (
	<MultiImageBlockComponent
		images={cloudinaryImages || (images && images)}
		logo={logo}
		logoPosition={logoPosition}
		populateImagesRightToLeft={populateImagesRightToLeft}
		populateImagesAsRows={populateImagesAsRows}
		columnProportions={columnProportions}
		photoCredit={photoCredit}
		styles={styles}
	/>
);

MultiImageBlock.propTypes = {
	cloudinaryImages: arrayOf(object),
	images: arrayOf(object),
	logo: arrayOf(object),
	logoPosition: oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
	populateImagesRightToLeft: bool,
	populateImagesAsRows: bool,
	columnProportions: string,
	photoCredit: string,
};
MultiImageBlock.defaultProps = {
	cloudinaryImages: null,
	images: [],
	logo: [],
	logoPosition: undefined,
	populateImagesRightToLeft: false,
	populateImagesAsRows: false,
	columnProportions: null,
	photoCredit: "",
};

export default MultiImageBlock;
export { MultiImageBlock };
